import type { StandingOrders } from './StandingOrders';

export const RO: Partial<StandingOrders> = {
    standingOrderIntervals: [
        'DAILY',
        'WEEKLY',
        'MONTHLY',
        'BI_MONTHLY',
        'QUARTERLY',
        'HALFYEARLY',
        'YEARLY',
    ],
    sweepOrderIntervals: [
        'DAILY',
        'WEEKLY',
        'MONTHLY',
        'BI_MONTHLY',
        'QUARTERLY',
        'HALFYEARLY',
        'YEARLY',
    ],
    /* Ensures to always use DUE_DAY_OF_MONTH */
    daysUntilLastOfMonth: 100,
    daysUntilLastOfMonthSweep: 100,
    daysFromTodayOutsideRange: 1,
    fetchReceiver: true,
};
